import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { TabsRendererProps } from '../src/components/TabsRenderer.tsx';

export const TabsRenderer: LoadableType<TabsRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TabsRenderer" */ '../src/components/TabsRenderer.tsx'
			)
		).TabsRenderer,
});
